import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useGetDriverLookup = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onGetDriverLookupError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while getting drivers lookup.',
        );
    };

    const onGetDriverLookupSuccess = (callbackFn: (...args: any) => void, navPath: string, searchParams: string) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        // toast.success(message ?? 'Driver lookup retrieved successfully.');
        callbackFn();
        navigate(`/${navPath}/${searchParams}/${encodeURIComponent(JSON.stringify(data))}`);
    };

    const getDriverLookup = (searchParams: any, navPath: string, callbackFn: (...args: any) => void) => {
        console.log('searchParams', searchParams);
        const url: HttpConfig = {
            url: `api/v1/dispatchers?search=${searchParams}`,
            method: 'get',
        };

        request(url, onGetDriverLookupSuccess(callbackFn, navPath, searchParams), setLoading, onGetDriverLookupError);
    };

    return { getDriverLookup, loading };
};

export default useGetDriverLookup;
